module.exports = __webpack_public_path__ + "img/003-man-1.d2bbd89c.svg";